import { handleActions } from 'redux-actions'
import { LOCATION_CHANGE } from 'connected-react-router'

import * as type from './type'


export const initialState = {
    caseList: [],
    fetching: false,
    error: null,
}


export default handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [type.FIND_UNASSIGNED_CASE_LIST_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_UNASSIGNED_CASE_LIST_SUCCESS]: (state, action) => {
        const { caseList } = action.payload
        return {
            ...state,
            caseList,
            fetching: false,
        }
    },
    [type.FIND_UNASSIGNED_CASE_LIST_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/threeshape/state/match/reducer.js